import { getData, postData, patchData, deleteData } from '../utils/api';

// Get all platform products with pagination and filters. When showUnitsSold is true, each product includes unitsSold.
export const getPlatformProducts = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    sortField = 'id',
    sortValue = 'DESC',
    postingAccount = '',
    productId = '',
    visibility = '',
    disabled = '',
    searchKey = '',
    showUnitsSold = false
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortField,
    sortValue,
    ...(postingAccount && { postingAccount }),
    ...(productId && { productId }),
    ...(visibility && { visibility }),
    ...(disabled && { disabled }),
    ...(searchKey && { searchKey }),
    ...(showUnitsSold && { showUnitsSold: 'true' })
  });

  return getData(`/data/platform-product?${queryParams.toString()}`);
};

// Search product options for dropdowns. Returns { product_options, hasNext } from platform_products. Paginated (page=1, limit=10), ordered by product name. Empty q returns first page of all products.
export const searchProductOptions = async (q = '', page = 1, limit = 10) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  const query = (q || '').trim();
  if (query) params.set('q', query);
  const response = await getData(`/data/platform-product/search-options?${params.toString()}`);
  return response;
};

// Get single platform product by ID or slug
export const getPlatformProductById = async (id) => {
  return getData(`/data/platform-product/${id}`);
};

// Create a new platform product
export const createPlatformProduct = async (productData) => {
  const {
    productId,
    postingAccount,
    productName,
    slug,
    sku,
    channelSku,
    channelProductId,
    sellingPrice,
    transferPrice,
    mrp,
    msp,
    currency,
    visibility = true,
    disabled = false
  } = productData;
  
  const requestData = {
    productId: productId || null,
    postingAccount,
    productName,
    slug,
    sku,
    channelSku,
    channelProductId,
    sellingPrice,
    transferPrice,
    mrp,
    msp,
    currency,
    visibility,
    disabled
  };
  
  return postData('/data/platform-product', requestData);
};

// Update an existing platform product
export const updatePlatformProduct = async (productData) => {
  const {
    platformProductId,
    productId,
    postingAccount,
    productName,
    slug,
    sku,
    channelSku,
    channelProductId,
    sellingPrice,
    transferPrice,
    mrp,
    msp,
    currency,
    visibility,
    disabled
  } = productData;
  
  const updateData = { platformProductId };
  
  if (productId !== undefined) updateData.productId = productId;
  if (postingAccount !== undefined) updateData.postingAccount = postingAccount;
  if (productName !== undefined) updateData.productName = productName;
  if (slug !== undefined) updateData.slug = slug;
  if (sku !== undefined) updateData.sku = sku;
  if (channelSku !== undefined) updateData.channelSku = channelSku;
  if (channelProductId !== undefined) updateData.channelProductId = channelProductId;
  if (sellingPrice !== undefined) updateData.sellingPrice = sellingPrice;
  if (transferPrice !== undefined) updateData.transferPrice = transferPrice;
  if (mrp !== undefined) updateData.mrp = mrp;
  if (msp !== undefined) updateData.msp = msp;
  if (currency !== undefined) updateData.currency = currency;
  if (visibility !== undefined) updateData.visibility = visibility;
  if (disabled !== undefined) updateData.disabled = disabled;

  return patchData('/data/platform-product', updateData);
};

// Delete a platform product
export const deletePlatformProduct = async (platformProductId) => {
  return deleteData('/data/platform-product', {
    data: { platformProductId }
  });
};

export default {
  getPlatformProducts,
  getPlatformProductById,
  createPlatformProduct,
  updatePlatformProduct,
  deletePlatformProduct
};

